import type { CartLine } from '@/store/modules/cart';

const PREFIX = '[SPO-1137 CartCheckout]';

export function cartCheckoutLog(message: string, data?: unknown): void {
  if (data !== undefined) {
    console.log(`${PREFIX} ${message}`, data);
  } else {
    console.log(`${PREFIX} ${message}`);
  }
}

export function cartCheckoutWarn(message: string, data?: unknown): void {
  if (data !== undefined) {
    console.warn(`${PREFIX} ${message}`, data);
  } else {
    console.warn(`${PREFIX} ${message}`);
  }
}

export function cartCheckoutError(message: string, data?: unknown): void {
  if (data !== undefined) {
    console.error(`${PREFIX} ${message}`, data);
  } else {
    console.error(`${PREFIX} ${message}`);
  }
}

export function summarizeCartLine(line: Partial<CartLine>) {
  return {
    id: line.id,
    stickerId: line.stickerId,
    stickerTitle: line.stickerTitle,
    lineType: line.lineType,
    campaignType: line.campaignType,
    unitCost: line.unitCost,
    quantity: line.quantity,
    donationAmount: line.donationAmount,
    donationCauseId: line.donationCauseId,
    donationCauseIds: line.donationCauseIds,
    socialShopId: line.socialShopId,
  };
}

export function summarizeShopSticker(sticker: any) {
  return {
    id: sticker?.id,
    title: sticker?.title,
    campaignType: sticker?.campaignType,
    quickCosts: sticker?.quickCosts,
    causesCount: Array.isArray(sticker?.causes) ? sticker.causes.length : 0,
    causes: sticker?.causes,
    hasSocialShop: !!sticker?.socialShop?.id,
  };
}

export function summarizeCartAmountEntry(entry: {
  sticker: any;
  unitCost: number;
  quantity: number;
  donationAmount?: number;
  donationCauseIds?: string[];
}) {
  return {
    sticker: summarizeShopSticker(entry.sticker),
    unitCost: entry.unitCost,
    quantity: entry.quantity,
    donationAmount: entry.donationAmount,
    donationCauseIds: entry.donationCauseIds,
  };
}
